import { RedoModalHostElement } from "../modal-host-element";

/**
 * Shadow-host custom element for the HSA/FSA cart eligibility widget.
 *
 * The "Learn more" dialog cannot live in the widget's own shadow root because
 * that root sits inside the theme's cart drawer, whose stacking context and
 * overflow would clip it; the base class hosts it on `document.body` instead.
 */
export class RedoHsaCartContainerElement extends RedoModalHostElement {
  constructor() {
    super("redo-hsa-cart-modal-root");
  }

  static readonly TAG = "redo-hsa-cart-container-element";
}
